import styled from 'styled-components';
import { fontSize, Box, palette, spacing } from '@landr/maestro';

const Wrapper = styled(Box)`
    display: flex;
    align-items: flex-start;
    color: ${palette('neutral.500')};
    padding: ${spacing('xs')} 0;
    cursor: default;

    ${({ theme }): string => theme.breakpoint('md')` 
        font-size: ${fontSize('sm')};
        font-weight: 'bold';
        padding: ${spacing('lg')} ${spacing('sm')} ${spacing('xs')};
    `}
`;

export default {
    Wrapper,
};
